module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-fr-FR.a73f4bdc.jpg";